import { useEffect, useState } from "react";
import { HQ } from "./sportConfig";

// Explicit links override this device's preference without rewriting it.
export default function useLeagueSelection(searchParams, view = "daily") {
  const key = `${HQ.storagePrefix}-${view}-leagues`;
  const [saved, setSaved] = useState(() => {
    try {
      const value = JSON.parse((window.SportsHQSettings || window.localStorage).getItem(key) || "[]");
      return Array.isArray(value) ? value.filter(item => typeof item === "string" && item) : [];
    } catch { return []; }
  });
  useEffect(()=>{
    const sync=()=>{try{const value=JSON.parse((window.SportsHQSettings || window.localStorage).getItem(key) || '[]');setSaved(Array.isArray(value)?value.filter(item=>typeof item==='string' && item):[]);}catch{setSaved([]);}};
    window.addEventListener('sports-hq-settings-state',sync);
    return ()=>window.removeEventListener('sports-hq-settings-state',sync);
  },[key]);
  const selected = searchParams.has("league") ? searchParams.getAll("league").filter(Boolean) : saved;
  const save = value => {
    setSaved(value);
    try { (window.SportsHQSettings || window.localStorage).setItem(key, JSON.stringify(value)); } catch {}
  };
  return [selected, save];
}
